import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { clearTokens, getStorageToken } from "../config/firebase";

const AdminProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const userTokenAvailable = getStorageToken();
  if (
    !userTokenAvailable ||
    (user && user.role !== "admin" && user.role !== "employee")
  ) {
    clearTokens();
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default AdminProtectedRoute;
